import {
  ITEM_DEFINITION_CODES,
  ITEM_STATUSES,
  STATES,
  ITEM_KINDS,
} from '../../../constants';
import { actions, selectors } from '../../../state';
import { merge } from 'lodash-es';
import { view, lensPath, find } from 'ramda';
import { track, trackOn } from '@updater-core/lib/tracker';
import './home-security.app.js';
import { trackEngagement } from '@mover-app/engagement';

export const BASE_PATH = '/home-security';
export function HomeSecurityConfig($stateProvider) {
  'ngInject';

  $stateProvider.state(STATES.STEP_HOME_SECURITY, {
    url: `${BASE_PATH}/*path?confirmationNumber`,
    disableBreadcrumb: true,
    views: {
      '@': {
        template: '<upd-home-security></upd-home-security>',
        controller: (updStore, $element, $scope) => {
          const app = $element.find('upd-home-security')[0];
          const state = getState(updStore);
          const tracker = setupTracker(app, $scope);
          updStore.dispatch(actions.step.isTerminalRoute());

          const updateItemState = function () {
            const state = updStore.getState();
            const item = selectors.current.findItemByKind(
              ITEM_KINDS.HOME_SECURITY,
              state
            );

            return updStore.dispatch(
              actions.item.singleton(item.id(state)).read()
            );
          };

          const goToError = function () {
            return updStore.dispatch(actions.router.stateGo(STATES.ERROR));
          };

          const goToDashboard = function () {
            return updStore.dispatch(actions.router.stateGo(STATES.DASHBOARD));
          };

          trackEngagement({
            name: 'Home Security',
            code: ITEM_DEFINITION_CODES.HOME_SECURITY,
          });
          app.value = {
            ...state,
            tracker,
            stateInterface: {
              updateItemState,
              goToDashboard,
              goToError,
            },
          };
        },
      },
    },
    scrollTop: true,
    analytics: {
      ignore: true,
    },
    data: {
      permissions: 'signedIn',
      moveItem: {
        type: ITEM_KINDS.HOME_SECURITY,
        singleton: true,
      },
    },
    title: 'Protect Your Home',
  });
}

function setupTracker(app, $scope) {
  const generateEvent = (attributes) =>
    merge(
      {},
      {
        domain: 'home_security',
        page: {
          name: (() => {
            const {
              currentPath,
              config: { routes },
            } = app.router;
            const routeKey = find((val) => currentPath.match(new RegExp(val)))(
              Object.keys(routes).reverse()
            );
            const currentRoute = routes[routeKey];
            const name = view(
              lensPath(['data', 'analytics', 'event']),
              currentRoute
            );
            return name;
          })(),
        },
      },
      attributes
    );

  const trackOff = trackOn(app, generateEvent);

  $scope.$on('$destroy', trackOff);

  return {
    track: (attributes) => track(generateEvent(attributes)),
  };
}

function getState(updStore) {
  const state = updStore.getState();
  const { current, session } = selectors;

  const { email, homePhone, cellPhone } = current.user(state);
  const move = current.move(state);

  // TODO: If this is the first time we enter the step, the creation of the
  // move item is still in-flight and `item` will still be `undefined` locally.
  const getStatus = () => {
    const state = updStore.getState();
    const item = selectors.current.findItemByKind(
      ITEM_KINDS.HOME_SECURITY,
      state
    );
    return item ? item.status(state) : ITEM_STATUSES.STARTED;
  };

  return {
    moveId: move.id(state),
    user: {
      email: email(state),
      phone: cellPhone(state) || homePhone(state),
    },
    sessionHeaders: {
      ...session.headers(state),
      app: 'mover',
    },
    getStatus,
  };
}
